<!--<template>-->
<!--    <div class="px-6 py-10">-->
<!--        <div class="w-full mx-auto py-10">-->
<!--            <Swiper-->
<!--                :centered-slides="true"-->
<!--                :grab-cursor="true"-->
<!--                :loop="true"-->
<!--                :pagination="{ clickable: true }"-->
<!--                :slides-per-view="3"-->
<!--                :space-between="20"-->
<!--                class="mySwiper"-->
<!--            >-->
<!--                <SwiperSlide-->
<!--                    v-for="(card, index) in cards"-->
<!--                    :key="index"-->
<!--                    class="transition-transform duration-300"-->
<!--                >-->
<!--                    <div-->
<!--                        class="h-full rounded-lg shadow-lg flex flex-col text-xl font-bold h-60"-->
<!--                    >-->

<!--                        &lt;!&ndash; Account info &ndash;&gt;-->
<!--                        <div class="flex flex-col">-->
<!--                            <img class="w-full h-full rounded-lg" :src="card.src" alt="">-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </SwiperSlide>-->
<!--            </Swiper>-->
<!--        </div>-->

<!--        &lt;!&ndash; middle box &ndash;&gt;-->
<!--        <div class="flex space-x-4 my-4 bg-gray-100">-->
<!--            <div class="w-1/3 flex-1 bg-gray-200 rounded-lg p-4 flex items-center space-x-4">-->
<!--                <div class="bg-white p-2 rounded-full shadow">-->
<!--                    <svg class="h-6 w-6 text-gray-600" fill="none" stroke="currentColor"-->
<!--                         stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                        <path d="M12 8v4l3 3" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                        <circle cx="12" cy="12" fill="none" r="10" stroke="currentColor" stroke-width="2"/>-->
<!--                    </svg>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <div class="text-base uppercase font-bold text-gray-600">Last Authentication</div>-->
<!--                    <div class="text-sm font-semibold text-gray-500">{{ displayTime }} UTC</div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <router-link to="/operations" class="w-1/3 flex items-center bg-white rounded-lg p-4 gap-x-2">-->
<!--                <div class="flex-1 flex items-center space-x-4">-->
<!--                    <div class="bg-white p-2 rounded-lg border border-gray-300">-->
<!--                        <svg class="h-6 w-6 text-gray-600" fill="none" stroke="currentColor"-->
<!--                             stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path-->
<!--                                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"/>-->
<!--                        </svg>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <div class="text-base uppercase font-bold text-gray-600">Pending Operations</div>-->
<!--                        <div class="text-sm font-semibold text-gray-500">You have no pending operations to perform!-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <component :is="ChevronRight"/>-->
<!--                </div>-->
<!--            </router-link>-->

<!--            <router-link to="/messages" class="w-1/3 flex items-center bg-white rounded-lg p-4 gap-x-2">-->
<!--                <div class="flex-1 flex items-center space-x-4">-->
<!--                    <div class="bg-white p-2 rounded-lg border border-gray-300">-->
<!--                        <svg class="h-6 w-6 text-gray-600" fill="none" stroke="currentColor"-->
<!--                             stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path-->
<!--                                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m0 8v-8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2z"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"/>-->
<!--                        </svg>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <div class="text-base uppercase font-bold text-gray-600">Messages</div>-->
<!--                        <div class="text-sm font-semibold text-gray-500">You have no messages to read!</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <component :is="ChevronRight"/>-->
<!--                </div>-->
<!--            </router-link>-->

<!--        </div>-->

<!--        &lt;!&ndash; bottom content &ndash;&gt;-->
<!--        <div class="grid grid-cols-3 gap-4">-->
<!--            <div class="max-w-sm w-full">-->
<!--                &lt;!&ndash; Title &ndash;&gt;-->
<!--                <h2 class="text-gray-700 text-lg font-semibold mb-4">CONSOLIDATED VIEW</h2>-->

<!--                <div class="bg-white rounded-2xl shadow-md p-4 flex flex-col items-center">-->
<!--                    &lt;!&ndash; Doughnut Chart and Radio &ndash;&gt;-->
<!--                    <div v-show="visibleCard === 'chart'" class="flex items-center justify-between w-full">-->
<!--                        &lt;!&ndash; Chart &ndash;&gt;-->
<!--                        <div class="w-32 h-32 relative">-->
<!--                            <canvas ref="chartCanvas"></canvas>-->
<!--                            <div-->
<!--                                class="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-700"-->
<!--                            >-->
<!--                                EUR 82.30-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        &lt;!&ndash; Radio Buttons &ndash;&gt;-->
<!--                        <div class="flex flex-col ml-4 space-y-2">-->
<!--                            <label class="flex items-center space-x-2">-->
<!--                                <input-->
<!--                                    class="w-4 h-4 text-blue-500 focus:ring-blue-400"-->
<!--                                    name="account"-->
<!--                                    type="radio"-->
<!--                                />-->
<!--                                <span class="text-sm text-gray-700">Deposits</span>-->
<!--                                <span class="text-sm font-medium text-gray-900">EUR 82.30</span>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Details &ndash;&gt;-->
<!--                    <div v-show="visibleCard === 'detail'" class="w-full px-2 py-4">-->
<!--                        &lt;!&ndash; Deposits Section&ndash;&gt;-->
<!--                        <div class="mb-2 border-b border-primary">-->
<!--                            <h3 class="text-primary font-medium text-sm">DEPOSITS</h3>-->

<!--                            <div class="space-y-1 divide-y divide-yellow-500">-->
<!--                                <div class="flex justify-between items-center">-->
<!--                                    <span class="text-gray-600 text-sm">Current Account EUR</span>-->
<!--                                    <span class="text-gray-800">EUR 82.30</span>-->
<!--                                </div>-->

<!--                                <div class="flex justify-between items-center">-->
<!--                                    <span class="text-gray-600 text-sm">Current account USD</span>-->
<!--                                    <div class="text-right">-->
<!--                                        <div class="text-gray-800">USD 0.00</div>-->
<!--                                        <div class="text-gray-500 text-xs">[EUR 0.00]</div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <div class="flex justify-between items-center">-->
<!--                                    <span class="text-gray-600 text-sm">Digital Investment Account USD</span>-->
<!--                                    <div class="text-right">-->
<!--                                        <div class="text-gray-800">USD 0.00</div>-->
<!--                                        <div class="text-gray-500 text-xs">[EUR 0.00]</div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <div class="flex justify-between items-center py-1">-->
<!--                                    <span class="text-gray-600 text-sm">Digital Investment Account EUR</span>-->
<!--                                    <span class="text-gray-800">EUR 0.00</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        &lt;!&ndash; Assets Section&ndash;&gt;-->
<!--                        <div class="mb-6">-->
<!--                            <div class="flex justify-between items-center">-->
<!--                                <h3 class="text-primary font-medium text-sm">ASSETS</h3>-->
<!--                                <span class="text-green-600 font-semibold text-lg">EUR 82.30</span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Toggle Buttons &ndash;&gt;-->
<!--                    <div class="flex mt-6 space-x-2 bg-gray-50 rounded-xl shadow-sm p-1">-->
<!--                        <button-->
<!--                            class="p-2 bg-white rounded-lg shadow text-gray-700 hover:bg-gray-100"-->
<!--                            @click="changeVisibleCard('chart')"-->
<!--                        >-->
<!--                            📊-->
<!--                        </button>-->
<!--                        <button-->
<!--                            class="p-2 bg-white rounded-lg shadow text-gray-700 hover:bg-gray-100"-->
<!--                            @click="changeVisibleCard('detail')"-->
<!--                        >-->
<!--                            📋-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->

<!--            <div class="col-span-2">-->
<!--                <div class="mx-auto">-->
<!--                    <div class="flex justify-between items-center p-4 border-b border-gray-200 cursor-pointer"-->
<!--                         @click="toggleOpenDeposit">-->
<!--                        <h3 class="font-semibold text-gray-700 uppercase text-sm">Deposits</h3>-->
<!--                        <div class="flex items-center space-x-2 text-gray-600">-->
<!--                            <span>EUR 82.30</span>-->
<!--                            <svg v-if="isOpenDeposit" class="h-5 w-5" fill="none" stroke="currentColor"-->
<!--                                 stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M5 15l7-7 7 7" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->
<!--                            <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2"-->
<!--                                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M19 9l-7 7-7-7" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <ul v-show="isOpenDeposit" class="divide-y divide-gray-200 bg-white rounded-lg shadow">-->
<!--                      <li v-for="(item, index) in items" :key="index"-->
<!--                          class="flex justify-between items-center p-4 hover:bg-gray-50 cursor-pointer">-->
<!--                        <div class="flex items-center space-x-3">-->
<!--                          <div class="bg-gray-100 p-2 rounded">-->
<!--                            &lt;!&ndash; آیکون &ndash;&gt;-->
<!--                          </div>-->
<!--                          <div>-->
<!--                            <div class="text-sm font-semibold text-gray-700">{{ item.title }}</div>-->
<!--                            <div class="text-xs text-gray-400">{{ item.subTitle }}</div>-->
<!--                          </div>-->
<!--                        </div>-->

<!--                        <div class="flex items-center space-x-3">-->
<!--                          <div class="text-sm font-semibold text-gray-700">{{ item.amount }}</div>-->
<!--                          <svg class="h-5 w-5 text-gray-400 ml-2" fill="none" stroke="currentColor"-->
<!--                               stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                          </svg>-->
<!--                        </div>-->
<!--                      </li>-->

<!--                    </ul>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--    </div>-->

<!--</template>-->

<template>
  <div class="px-6 py-10">
    <div class="w-full mx-auto py-10">
      <Swiper
          :centered-slides="true"
          :grab-cursor="true"
          :loop="true"
          :pagination="{ clickable: true }"
          :slides-per-view="3"
          :space-between="20"
          class="mySwiper"
      >
        <SwiperSlide
            v-for="(card, index) in cards"
            :key="index"
            class="transition-transform duration-300"
        >
          <div
              class="h-full rounded-lg shadow-lg flex flex-col text-xl font-bold h-60"
          >
            <!-- Account info -->
            <div class="flex flex-col">
              <img class="w-full h-full rounded-lg" :src="card.src" alt="" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>

    <!-- middle box -->
    <div class="flex space-x-4 my-4 bg-gray-100">
      <div
          class="w-1/3 flex-1 bg-gray-200 rounded-lg p-4 flex items-center space-x-4"
      >
        <div class="bg-white p-2 rounded-full shadow">
          <svg
              class="h-6 w-6 text-gray-600"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M12 8v4l3 3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <circle
                cx="12"
                cy="12"
                fill="none"
                r="10"
                stroke="currentColor"
                stroke-width="2"
            />
          </svg>
        </div>
        <div>
          <div class="text-base uppercase font-bold text-gray-600">
            Last Authentication
          </div>
          <div class="text-sm font-semibold text-gray-500">
            {{ displayTime }} UTC
          </div>
        </div>
      </div>

      <router-link
          to="/operations"
          class="w-1/3 flex items-center bg-white rounded-lg p-4 gap-x-2"
      >
        <div class="flex-1 flex items-center space-x-4">
          <div class="bg-white p-2 rounded-lg border border-gray-300">
            <svg
                class="h-6 w-6 text-gray-600"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
            </svg>
          </div>
          <div>
            <div class="text-base uppercase font-bold text-gray-600">
              Pending Operations
            </div>
            <div class="text-sm font-semibold text-gray-500">
              You have no pending operations to perform!
            </div>
          </div>
        </div>
        <div>
          <component :is="ChevronRight" />
        </div>
      </router-link>

      <router-link
          to="/messages"
          class="w-1/3 flex items-center bg-white rounded-lg p-4 gap-x-2"
      >
        <div class="flex-1 flex items-center space-x-4">
          <div class="bg-white p-2 rounded-lg border border-gray-300">
            <svg
                class="h-6 w-6 text-gray-600"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m0 8v-8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
            </svg>
          </div>
          <div>
            <div class="text-base uppercase font-bold text-gray-600">
              Messages
            </div>
            <div class="text-sm font-semibold text-gray-500">
              You have no messages to read!
            </div>
          </div>
        </div>
        <div>
          <component :is="ChevronRight" />
        </div>
      </router-link>
    </div>

    <!-- bottom content -->
    <div class="grid grid-cols-3 gap-4">
      <div class="max-w-sm w-full">
        <!-- Title -->
        <h2 class="text-gray-700 text-lg font-semibold mb-4">
          CONSOLIDATED VIEW
        </h2>

        <div
            class="bg-white rounded-2xl shadow-md p-4 flex flex-col items-center"
        >
          <!-- Doughnut Chart and Radio -->
          <div
              v-show="visibleCard === 'chart'"
              class="flex items-center justify-between w-full"
          >
            <!-- Chart -->
            <div class="w-32 h-32 relative">
              <canvas ref="chartCanvas"></canvas>
              <div
                  class="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-700"
              >
                EUR {{ totalDeposits }}
              </div>
            </div>

            <!-- Radio Buttons -->
            <div class="flex flex-col ml-4 space-y-2">
              <label class="flex items-center space-x-2">
                <input
                    class="w-4 h-4 text-blue-500 focus:ring-blue-400"
                    name="account"
                    type="radio"
                />
                <span class="text-sm text-gray-700">Deposits</span>
                <span class="text-sm font-medium text-gray-900">
                  EUR {{ totalDeposits }}
                </span>
              </label>
            </div>
          </div>

          <!-- Details -->
          <div v-show="visibleCard === 'detail'" class="w-full px-2 py-4">
            <!-- Deposits Section-->
            <div class="mb-2 border-b border-primary">
              <h3 class="text-primary font-medium text-sm">DEPOSITS</h3>

              <div class="space-y-1 divide-y divide-yellow-500">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="flex justify-between items-center py-1"
                >
                  <span class="text-gray-600 text-sm">{{ item.title }}</span>
                  <span class="text-gray-800">{{ item.amount }}</span>
                </div>
              </div>
            </div>

            <!-- Assets Section-->
            <div class="mb-6">
              <div class="flex justify-between items-center">
                <h3 class="text-primary font-medium text-sm">ASSETS</h3>
                <span class="text-green-600 font-semibold text-lg">
                  EUR {{ totalDeposits }}
                </span>
              </div>
            </div>
          </div>

          <!-- Toggle Buttons -->
          <div
              class="flex mt-6 space-x-2 bg-gray-50 rounded-xl shadow-sm p-1"
          >
            <button
                class="p-2 bg-white rounded-lg shadow text-gray-700 hover:bg-gray-100"
                @click="changeVisibleCard('chart')"
            >
              📊
            </button>
            <button
                class="p-2 bg-white rounded-lg shadow text-gray-700 hover:bg-gray-100"
                @click="changeVisibleCard('detail')"
            >
              📋
            </button>
          </div>
        </div>
      </div>

      <div class="col-span-2">
        <div class="mx-auto">
          <div
              class="flex justify-between items-center p-4 border-b border-gray-200 cursor-pointer"
              @click="toggleOpenDeposit"
          >
            <h3 class="font-semibold text-gray-700 uppercase text-sm">
              Deposits
            </h3>
            <div class="flex items-center space-x-2 text-gray-600">
              <span>EUR {{ totalDeposits }}</span>
              <svg
                  v-if="isOpenDeposit"
                  class="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M5 15l7-7 7 7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
              </svg>
              <svg
                  v-else
                  class="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M19 9l-7 7-7-7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <ul
              v-show="isOpenDeposit"
              class="divide-y divide-gray-200 bg-white rounded-lg shadow"
          >
            <li
                v-for="(item, index) in items"
                :key="index"
                class="flex justify-between items-center p-4 hover:bg-gray-50 cursor-pointer"
                @click="$router.push('/view/balance')"
            >
              <div class="flex items-center space-x-3">
                <div class="bg-gray-100 p-2 rounded">
                  <svg
                      class="h-6 w-6 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M9 12h6m-6 4h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h5l5 5v9a2 2 0 01-2 2z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <div class="text-sm font-semibold text-gray-700">
                    {{ item.title }}
                  </div>
                  <div class="text-xs text-gray-400">
                    {{ item.subTitle }}
                  </div>
                </div>
              </div>

              <div class="flex items-center space-x-3">
                <div class="text-sm font-semibold text-gray-700">
                  {{ item.amount }}
                </div>
                <svg
                    class="h-5 w-5 text-gray-400 ml-2"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M9 5l7 7-7 7"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                  />
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>



<script setup>

import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import SwiperCore, {Navigation, Pagination} from 'swiper'
import {onMounted, ref} from 'vue'
import {ArcElement, Chart, DoughnutController, Legend, Tooltip} from 'chart.js'
import {ChevronRight} from 'lucide-vue-next';
import Image1 from '@/assets/img/Malhadinha-Nova-3.webp';
import api from "@/services/api";

SwiperCore.use([Pagination, Navigation])

const cards = [
    // {title: 'Current Account EUR', accountNumber: '0108855/001.000.978', type: 'EUR', balance: '82.00' },
    // {title: 'Current Account USD', accountNumber: '0108855/001.000.978', type: 'USD', balance: '24.00' },
    // {title: 'Digital Invest Account USD', accountNumber: '0108855/001.000.978', type: 'USD', balance: '0.00' },
    // {title: 'Current Account EUR', accountNumber: '0108855/001.000.978', type: 'EUR', balance: '82.00' },
    { title: '', src: Image1 },
    { title: '', src: Image1 },
    { title: '', src: Image1 },
    { title: '', src: Image1 },
    { title: '', src: Image1 },
]

const displayTime = ref('') // reactive
const isOpenDeposit = ref(true);
// const isOpenCard = ref(true);
const items = ref([
    {
        title: "Current Account EUR",
        subTitle: "0108855/001.000.978",
        amount: "EUR 82.30"
    },
    {
        title: "Current account USD",
        subTitle: "0108855/001.000.840",
        amount: "USD 0.00"
    },
    {
        title: "Digital Investment Account USD",
        subTitle: "0108855/001.006.840",
        amount: "USD 0.00"
    },
    {
        title: "Digital Investment Account EUR",
        subTitle: "0108855/001.006.978",
        amount: "EUR 0.00"
    }
])

function toggleOpenDeposit() {
    isOpenDeposit.value = !isOpenDeposit.value
}

// function toggleOpenCard() {
//     isOpenCard.value = !isOpenCard.value
// }

const visibleCard = ref("chart");

function changeVisibleCard(value) {
    visibleCard.value = value;
}

Chart.register(ArcElement, Tooltip, Legend, DoughnutController);

const chartCanvas = ref(null);

onMounted(() => {
    new Chart(chartCanvas.value, {
        type: "doughnut",
        data: {
            labels: ["Deposits", "Others"],
            datasets: [
                {
                    // data: [82.3, 17.7],
                    data: [82.3],
                    backgroundColor: ["#4B5563", "#E5E7EB"],
                    borderWidth: 0,
                },
            ],
        },
        options: {
            cutout: "70%",
            plugins: {
                legend: {display: false},
                tooltip: {enabled: false},
            },
        },
    });


  const utcStr = localStorage.getItem('utc')
  if (utcStr) {
    const utcTime = JSON.parse(utcStr) // parse کنید اگر stringify شده
    const date = new Date(utcTime)
    if (!isNaN(date)) {
      displayTime.value = date.toLocaleString('en-US', {
        timeZone: 'UTC',
        hour12: true
      })
    } else {
      console.error('Invalid UTC date:', utcTime)
    }
  }

  fetchDeposits();

});







const totalDeposits = ref(0) // جمع کل
async function fetchDeposits() {
  try {
    const { data } = await api.get('/movements/deposits', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })  // مسیر API لاراول
    items.value = data.deposits.map(dep => ({
      title: dep.account?.name || 'Account',
      subTitle: dep.account?.account_number || '',
      amount: `${dep.currency} ${dep.value}`
    }))
    totalDeposits.value = data.total_deposits
  } catch (error) {
    console.error('Failed to fetch deposits:', error)
  }
}





</script>

<style>
.mySwiper .swiper-slide {
    opacity: 0.5;
    transform: scale(0.85);
    transition: all 0.3s ease;
}

.mySwiper .swiper-slide-active {
    opacity: 1 !important;
    transform: scale(1) !important;
}

.mySwiper .swiper-slide-active div {
    background-color: #ececec;
}
</style>
